/**
 * Single source of truth for "our games" – used by Header (search) and Footer.
 * Only games in this list are shown in the site navigation and footer.
 */

export const ALL_GAME_NAMES = [
  '8 Ball Pool',
  '99 Nights in the Forest',
  'Adopt Me',
  'Albion Online',
  'All Star Tower Defense X',
  'Animal Crossing: New Horizons',
  'Anime Defenders',
  'Anime Vanguards',
  'Apex Legends',
  'Arc Raiders',
  'Arena Breakout',
  'Arena Breakout: Infinite',
  'ARK: Survival Ascended',
  'Arknights',
  'Ayakashi Rumble!',
  'Battlefield',
  'Battlenet',
  'Black Clover M',
  'Black Desert Online',
  'Bleach: Brave Souls',
  'Blood Strike',
  'Blox Fruits',
  'Brawl Stars',
  'Call of Duty',
  'Call of Duty Mobile',
  'Car Parking Multiplayer',
  'Chaos Zero Nightmare',
  'Chocotto Land',
  'Clash of Clans',
  'Clash Royale',
  'Cookie Run: Kingdom',
  'Counter-Strike 2',
  'Crunchyroll',
  'Dark and Darker',
  'DarkOrbit',
  'DayZ',
  'Dead By Daylight',
  'Dead Rails',
  'Delta Force',
  'Destiny 2',
  'Diablo 4',
  'Diablo Immortal',
  'Digimon Super Rumble',
  'Discord',
  'DonutSMP',
  'Dota 2',
  'Dragon Ball Legends',
  'Dragon Ball Z Dokkan Battle',
  'Duet Night Abyss',
  'EA Sports FC',
  'EA Sports FC Mobile',
  'eFootball',
  'Elden Ring',
  'Elder Scrolls Online',
  'Epic Games',
  'Epic Seven',
  'Escape from Tarkov',
  'Etheria: Restart',
  'Fallout 76',
  'Fate/Grand Order',
  'Final Fantasy XIV',
  'Fisch',
  'Fortnite',
  'Forza Horizon 5',
  'Garena Free Fire',
  'Genshin Impact',
  'Girls Frontline 2: Exilium',
  'Goddess of Victory: Nikke',
  'Golden HoYeah',
  'Granblue Fantasy',
  'Grand Roleplay',
  'Grand Theft Auto 5',
  'Grow a Garden',
  'Hay Day',
  'Honkai Impact 3rd',
  'Honkai: Star Rail',
  'Houchi Shoujo',
  'Identity V',
  'Jailbreak',
  "JoJo's Bizarre Adventure: Ora Ora Overdrive",
  'Jujutsu Infinite',
  'Jujutsu Kaisen Phantom Parade',
  'Kaiju No. 8',
  'King Legacy',
  'Knight Online',
  'Knives Out',
  'Last Island of Survival',
  'Last War: Survival',
  'League of Legends',
  'League of Legends: Wild Rift',
  'Livly Island',
  'Lords Mobile',
  'Lost Ark',
  'Madoka Magica Magia Exedra',
  'Marvel Contest of Champions',
  'Marvel Rivals',
  'Metin2',
  'Millennium War Aigis',
  'Minecraft',
  'Mobile Legends',
  'Monster Hunter Now',
  'Monster Strike',
  'Netflix',
  'New World',
  'Old School RuneScape',
  'One Piece Bounty Rush',
  'One Piece Treasure Cruise',
  'Origin',
  'Overwatch 2',
  'Path of Exile',
  'Path of Exile 2',
  'Persona 5: The Phantom X',
  'Plants vs Brainrots',
  'PlayStation',
  'Pokecolo',
  'Pokecolo Twin',
  'Pokemon Go',
  'Pokemon TCG Pocket',
  'Princess Connect! Re:Dive',
  'Professional Baseball Spirits A',
  'Project SEKAI',
  'PUBG',
  'PUBG Mobile',
  'Puzzle and Dragons',
  'Raid: Shadow Legends',
  'Rainbow Six Siege X',
  'Rise of Kingdoms',
  'Roblox',
  'Rocket League',
  'Royale Online',
  'RuneScape 3',
  'Rust',
  'SD Gundam G Generation ETERNAL',
  'Sea of Thieves',
  'Seven Knights Re:BIRTH',
  'Shadowverse',
  'Silver and Blood',
  'Sky: Children of the Light',
  'Spotify',
  'Standoff 2',
  'Steal a Brainrot',
  'Stella Sora',
  'Summoners War',
  'The Finals',
  'The First Descendant',
  'The Forge',
  'The Seven Deadly Sins',
  'Throne and Liberty',
  'Tower of Fantasy',
  'Ubisoft Connect',
  'Uma Musume Pretty Derby',
  'unVEIL the world',
  'Valorant',
  'Volleyball Legends',
  'War Thunder',
  'Warframe',
  'Wartune Ultra',
  'Watcher of Realms',
  'Where Winds Meet',
  'White Cat Project',
  'Whiteout Survival',
  'WolfTeam',
  'World of Tanks',
  'World of Warcraft',
  'World of Warships',
  'WoW Classic',
  'WoW Mists of Pandaria',
  'Wuthering Waves',
  'Yo-kai Watch: Wibble Wobble',
  'Yu-Gi-Oh! Master Duel',
  'Zenless Zone Zero',
  'Zula'
];

/** Map game name to URL slug (same logic as Header). */
export function getGameSlug(gameName) {
  const slugMap = {
    'COD Call of Duty': 'cod-call-of-duty',
    'Call of Duty': 'call-of-duty',
    'Call of Duty Mobile': 'call-of-duty-mobile',
    'Clash Royale': 'clash-royale',
    'Rocket League': 'rocket-league',
    'EA Sports FC': 'ea-sports-fc',
    'EA Sports FC Mobile': 'ea-sports-fc-mobile',
    'Apex Legends': 'apex-legends',
    'Arc Raiders': 'arc-raiders',
    'Valorant': 'valorant',
    'Old School RuneScape': 'old-school-runescape',
    'League of Legends': 'league-of-legends',
    'League of Legends: Wild Rift': 'league-of-legends-wild-rift',
    'Rainbow Six Siege': 'rainbow-six-siege',
    'Rainbow Six Siege X': 'rainbow-six-siege-x',
    'Roblox': 'roblox',
    'Escape from Tarkov': 'escape-from-tarkov',
    'Fortnite': 'fortnite',
    'Counter Strike 2': 'counter-strike-2',
    'Counter-Strike 2': 'counter-strike-2',
    'Warcraft': 'warcraft',
    'World of Warcraft': 'world-of-warcraft',
    'Minecraft': 'minecraft',
    'Path of Exile 2': 'path-of-exile-2',
    'Path of Exile': 'path-of-exile',
    'DonutSMP': 'donutsmp',
    'Hypixel': 'hypixel',
    'Arena Breakout: Infinite': 'arena-breakout-infinite',
    'Arena Breakout': 'arena-breakout',
    'Anime Vanguards': 'anime-vanguards',
    'Battlefield': 'battlefield',
    'Grand Roleplay': 'grand-roleplay'
  };
  return slugMap[gameName] || (gameName || '').toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
